import Vue from 'vue';
import config from 'common-module/src/config';
import http from 'common-module/src/util/http';
import tracking from 'common-module/src/plugin/tracking';
import router from '@/router';

tracking(Vue, config, { http });

router.afterEach((to, from) => {
  Vue.prototype.$track?.send('Page_View', {
    Previous_Page: from.path,
    Next_Page: to.path,
    First_Visit: !from.name
  }, true);
  Vue.nextTick(() => {
    Vue.prototype.$posthog?.capture('$pageview', {
      $current_url: to.fullPath
    });
  });
});
